export const AddIcon = () => (
  <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="#00AA67" />
    <path
      d="M6 15.6001H15.3M15.3 15.6001H24.6M15.3 15.6001V6.6001M15.3 15.6001V24.6001"
      stroke="white"
      strokeWidth="4.81004"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
